// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KnownPlans-module__font-s-10___tI8fG {
  font-size: 10px !important;
}

.KnownPlans-module__font-s-12___hTk6j {
  font-size: 12px !important;
}

.KnownPlans-module__font-s-13___Urdi0 {
  font-size: 13px !important;
}

.KnownPlans-module__font-s-14___o0X6g {
  font-size: 14px !important;
}

.KnownPlans-module__font-s-15___MMW2V {
  font-size: 15px !important;
}

.KnownPlans-module__font-s-16___b3fkd {
  font-size: 16px !important;
}

.KnownPlans-module__font-s-18___RPWSq {
  font-size: 18px !important;
}

.KnownPlans-module__font-s-20___Y06B1 {
  font-size: 20px !important;
}

.KnownPlans-module__font-s-22___aI6J0 {
  font-size: 22px !important;
}

.KnownPlans-module__font-s-28___s57XL {
  font-size: 28px !important;
}

.KnownPlans-module__font-w-400___CDNfx {
  font-weight: 400 !important;
}

.KnownPlans-module__font-w-500___i5kKo {
  font-weight: 500 !important;
}

.KnownPlans-module__font-w-600___giGEx {
  font-weight: 600 !important;
}

.KnownPlans-module__font-w-700___eLwtQ {
  font-weight: 700 !important;
}

.KnownPlans-module__p-5___A5ypO {
  padding: 5px !important;
}

.KnownPlans-module__p-12___PHeHX {
  padding: 12px !important;
}

.KnownPlans-module__p-16___oL9X6 {
  padding: 16px !important;
}

.KnownPlans-module__p-30___kBNLh {
  padding: 30px !important;
}

.KnownPlans-module__p-b-0___OWuSO {
  padding-bottom: 0 !important;
}

.KnownPlans-module__p-b-5___qHqny {
  padding-bottom: 5px !important;
}

.KnownPlans-module__p-b-10___DZDPD {
  padding-bottom: 10px !important;
}

.KnownPlans-module__p-b-12___HpSq7 {
  padding-bottom: 12px !important;
}

.KnownPlans-module__p-b-16___SpoY2 {
  padding-bottom: 16px !important;
}

.KnownPlans-module__p-b-18___aUnw6 {
  padding-bottom: 18px !important;
}

.KnownPlans-module__p-b-20___ZwsXD {
  padding-bottom: 20px !important;
}

.KnownPlans-module__p-b-25___aadML {
  padding-bottom: 25px !important;
}

.KnownPlans-module__p-b-30___U5CK6 {
  padding-bottom: 30px !important;
}

.KnownPlans-module__p-b-50___yBcuV {
  padding-bottom: 50px !important;
}

.KnownPlans-module__p-t-0___LhuNc {
  padding-top: 0 !important;
}

.KnownPlans-module__p-t-12___t7RV9 {
  padding-top: 12px !important;
}

.KnownPlans-module__p-t-16___peZ3k {
  padding-top: 16px !important;
}

.KnownPlans-module__p-t-18___U612B {
  padding-top: 18px !important;
}

.KnownPlans-module__p-t-20___wTN2l {
  padding-top: 20px !important;
}

.KnownPlans-module__p-t-30___Y0_eQ {
  padding-top: 30px !important;
}

.KnownPlans-module__p-t-40___CUP8x {
  padding-top: 40px !important;
}

.KnownPlans-module__p-t-50___HShWu {
  padding-top: 50px !important;
}

.KnownPlans-module__p-l-20___hGn4x {
  padding-left: 20px !important;
}

.KnownPlans-module__p-l-30___VjgXb {
  padding-left: 30px !important;
}

.KnownPlans-module__p-l-40___UPQP0 {
  padding-left: 40px !important;
}

.KnownPlans-module__p-r-16___WofCW {
  padding-right: 16px !important;
}

.KnownPlans-module__p-r-20___k2XTz {
  padding-right: 20px !important;
}

.KnownPlans-module__p-r-30___jStkF {
  padding-right: 30px !important;
}

.KnownPlans-module__p-r-50___pMyVY {
  padding-right: 50px !important;
}

.KnownPlans-module__p-r-60___Ge2Ff {
  padding-right: 60px !important;
}

.KnownPlans-module__m-b-1___LZhZ3 {
  margin-bottom: 1px !important;
}

.KnownPlans-module__m-b-2___M8_fr {
  margin-bottom: 2px !important;
}

.KnownPlans-module__m-b-6___kcsCD {
  margin-bottom: 6px !important;
}

.KnownPlans-module__m-b-8___GOA_y {
  margin-bottom: 8px !important;
}

.KnownPlans-module__m-b-10___a0oyx {
  margin-bottom: 10px !important;
}

.KnownPlans-module__m-b-14___M6sRy {
  margin-bottom: 14px !important;
}

.KnownPlans-module__m-b-16___iuRYh {
  margin-bottom: 16px !important;
}

.KnownPlans-module__m-b-20___Bt1gp {
  margin-bottom: 20px !important;
}

.KnownPlans-module__m-b-22___mFEQF {
  margin-bottom: 22px !important;
}

.KnownPlans-module__m-b-24___C3KW0 {
  margin-bottom: 24px !important;
}

.KnownPlans-module__m-b-30___VCgZ4 {
  margin-bottom: 30px !important;
}

.KnownPlans-module__m-b-32___VKgcw {
  margin-bottom: 32px !important;
}

.KnownPlans-module__m-b-40___ircS8 {
  margin-bottom: 40px !important;
}

.KnownPlans-module__m-t-2___jKP0D {
  margin-top: 2px !important;
}

.KnownPlans-module__m-t-3___fL78P {
  margin-top: 3px !important;
}

.KnownPlans-module__m-t-4___QtnRo {
  margin-top: 4px !important;
}

.KnownPlans-module__m-t-5___uyFdD {
  margin-top: 5px !important;
}

.KnownPlans-module__m-t-8___wuvRH {
  margin-top: 8px !important;
}

.KnownPlans-module__m-t-10___IMm4t {
  margin-top: 10px !important;
}

.KnownPlans-module__m-t-15___uBu6O {
  margin-top: 15px !important;
}

.KnownPlans-module__m-t-16___xso8O {
  margin-top: 16px !important;
}

.KnownPlans-module__m-t-20___LPW6g {
  margin-top: 20px !important;
}

.KnownPlans-module__m-t-22___vqC5Y {
  margin-top: 22px !important;
}

.KnownPlans-module__m-t-30___QAj7j {
  margin-top: 30px !important;
}

.KnownPlans-module__m-t-32___icTMt {
  margin-top: 32px !important;
}

.KnownPlans-module__m-l-auto___tkva8 {
  margin-left: auto !important;
}

.KnownPlans-module__m-l-4___WcBla {
  margin-left: 4px !important;
}

.KnownPlans-module__m-l-5___McYSY {
  margin-left: 5px !important;
}

.KnownPlans-module__m-l-6___Vu7jG {
  margin-left: 6px !important;
}

.KnownPlans-module__m-l-8___GBzO3 {
  margin-left: 8px !important;
}

.KnownPlans-module__m-l-10___1QF1j {
  margin-left: 10px !important;
}

.KnownPlans-module__m-l-16___a8TXb {
  margin-left: 16px !important;
}

.KnownPlans-module__m-l-20___R2pNQ {
  margin-left: 20px !important;
}

.KnownPlans-module__m-l-24___KMy1r {
  margin-left: 24px !important;
}

.KnownPlans-module__m-l-30___LfFJc {
  margin-left: 30px !important;
}

.KnownPlans-module__m-l-35___tOw_d {
  margin-left: 35px !important;
}

.KnownPlans-module__m-l-40___Mdnuf {
  margin-left: 40px !important;
}

.KnownPlans-module__m-r-8___hmpps {
  margin-right: 8px !important;
}

.KnownPlans-module__m-r-10___wDtOK {
  margin-right: 10px !important;
}

.KnownPlans-module__m-r-16___SbtdE {
  margin-right: 16px !important;
}

.KnownPlans-module__m-r-20___Ijf06 {
  margin-right: 20px !important;
}

.KnownPlans-module__m-r-24___HkArc {
  margin-right: 24px !important;
}

.KnownPlans-module__m-r-30___u6l1O {
  margin-right: 30px !important;
}

.KnownPlans-module__m-r-40____KApX {
  margin-right: 40px !important;
}

.KnownPlans-module__border-r-3___wWXn1 {
  border-radius: 3px !important;
}

.KnownPlans-module__border-r-4___Gg0rg {
  border-radius: 4px !important;
}

.KnownPlans-module__border-r-6___pKo1K {
  border-radius: 6px !important;
}

.KnownPlans-module__border-r-10___rqyO9 {
  border-radius: 10px !important;
}

.KnownPlans-module__border-r-12___aP53R {
  border-radius: 12px !important;
}

.KnownPlans-module__border-r-16___qpX0U {
  border-radius: 16px !important;
}

.KnownPlans-module__border-r-50___FLK3R {
  border-radius: 50% !important;
}

.KnownPlans-module__primary-border___aUZZ4 {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.KnownPlans-module__primary-border-b___D9Ttf {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.KnownPlans-module__primary-border-t___h4v3Z {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.KnownPlans-module__primary-border-l___wy6FB {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.KnownPlans-module__primary-border-r___LzW4B {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.KnownPlans-module__secondary-border___JuLBk {
  border: 1px solid #637768;
}

.KnownPlans-module__secondary-border-b___Qwe7p {
  border-bottom: 1px solid #637768;
}

.KnownPlans-module__secondary-border-t___WDKQa {
  border-top: 1px solid #637768;
}

.KnownPlans-module__secondary-border-l___jN0OI {
  border-left: 1px solid #637768;
}

.KnownPlans-module__secondary-border-r___OGjhO {
  border-right: 1px solid #637768;
}

.KnownPlans-module__gap-0___M3m7n {
  gap: 0 !important;
}

.KnownPlans-module__gap-2___q_mtQ {
  gap: 2px !important;
}

.KnownPlans-module__gap-4___kdMEt {
  gap: 4px !important;
}

.KnownPlans-module__gap-5___R52Y5 {
  gap: 5px !important;
}

.KnownPlans-module__gap-6___oY8pc {
  gap: 6px !important;
}

.KnownPlans-module__gap-8___mUuow {
  gap: 8px !important;
}

.KnownPlans-module__gap-10___NuCST {
  gap: 10px !important;
}

.KnownPlans-module__gap-12___mjqIf {
  gap: 12px !important;
}

.KnownPlans-module__gap-14___PZ0Tx {
  gap: 14px !important;
}

.KnownPlans-module__gap-16___kMrF3 {
  gap: 16px !important;
}

.KnownPlans-module__gap-18___WfCrk {
  gap: 18px !important;
}

.KnownPlans-module__gap-20___16fZP {
  gap: 20px !important;
}

.KnownPlans-module__gap-24___dHiW7 {
  gap: 24px !important;
}

.KnownPlans-module__gap-26___TpLRI {
  gap: 26px !important;
}

.KnownPlans-module__gap-30___a8BUz {
  gap: 30px !important;
}

.KnownPlans-module__gap-32___aZ5P6 {
  gap: 32px !important;
}

.KnownPlans-module__gap-40___JPOUT {
  gap: 40px !important;
}

.KnownPlans-module__gap-50___CxPM3 {
  gap: 50px !important;
}

.KnownPlans-module__flex-1___HEPUq {
  flex: 1;
}

.KnownPlans-module__flex-none___j1nGD {
  flex: none !important;
}

.KnownPlans-module__flex-column___tmUki {
  display: flex;
  flex-direction: column !important;
}

.KnownPlans-module__flex-row___EC4Qg {
  display: flex;
  flex-direction: row !important;
}

.KnownPlans-module__vertically-centered___QHSi9 {
  display: flex;
  align-items: center !important;
}

.KnownPlans-module__horizontally-centered___OT8L7 {
  display: flex;
  justify-content: center !important;
}

.KnownPlans-module__horizontally-end___nX46n {
  display: flex;
  justify-content: end !important;
}

.KnownPlans-module__vertically-start___MDIUq {
  display: flex;
  align-items: start !important;
}

.KnownPlans-module__space-between___w7WWF {
  display: flex;
  justify-content: space-between !important;
}

.KnownPlans-module__flex-wrap___n565R {
  flex-wrap: wrap !important;
}

.KnownPlans-module__height-100____7D64 {
  height: 100%;
}

.KnownPlans-module__width-50___JtWyl {
  width: 50% !important;
}

.KnownPlans-module__width-100___Mtd88 {
  width: 100%;
}

.KnownPlans-module__cursor-pointer___kd77m {
  cursor: pointer;
}

.KnownPlans-module__cursor-not-allowed___nn4fP {
  cursor: not-allowed !important;
}

.KnownPlans-module__absolute-centered___YWBym {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.KnownPlans-module__absolute___vY5EO {
  position: absolute;
}

.KnownPlans-module__relative___sPdZB {
  position: relative;
}

.KnownPlans-module__fixed___tdEkn {
  position: fixed;
}

.KnownPlans-module__visible___bfXXA {
  opacity: 1;
}

.KnownPlans-module__invisible___yTz4y {
  opacity: 0;
}

.KnownPlans-module__col-90___qS3Uf {
  width: 90% !important;
}

.KnownPlans-module__col-auto___XyX26 {
  width: auto !important;
}

.KnownPlans-module__medical-tabs___eN1yF {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.KnownPlans-module__medical-table-new___JhTv7 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.KnownPlans-module__medical-table-new___JhTv7:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.KnownPlans-module__medical-table-new___JhTv7::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.KnownPlans-module__medical-table-new___JhTv7::-webkit-scrollbar-track {
  display: none;
}
.KnownPlans-module__medical-table-new___JhTv7.KnownPlans-module__no-pagination___aRAgl {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.KnownPlans-module__medical-table-new___JhTv7.KnownPlans-module__no-pagination___aRAgl:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.KnownPlans-module__medical-table-new___JhTv7.KnownPlans-module__no-pagination___aRAgl::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.KnownPlans-module__medical-table-new___JhTv7.KnownPlans-module__no-pagination___aRAgl::-webkit-scrollbar-track {
  display: none;
}

.KnownPlans-module__medical-table-empty___xyG7O {
  padding: 14px 40px !important;
}

.KnownPlans-module__icon-btn___UVR4w {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.KnownPlans-module__search-icon___I2GdO {
  width: 24px;
  height: 24px;
  align-self: center;
}

.KnownPlans-module__disable-select___CvKQL {
  user-select: none;
}

.KnownPlans-module__break-word___N5KHl {
  word-break: break-word;
}

.KnownPlans-module__popup-clear-btn___QztpO {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.KnownPlans-module__scroll-m-b-20___PPPCg {
  scroll-margin-bottom: 20px;
}

.KnownPlans-module__container___qH2vh {
  display: flex;
  flex-direction: column;
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer));
  overflow-y: scroll;
  overflow-x: hidden;
}
.KnownPlans-module__container___qH2vh:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.KnownPlans-module__container___qH2vh::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.KnownPlans-module__container___qH2vh::-webkit-scrollbar-track {
  display: none;
}
.KnownPlans-module__container___qH2vh .KnownPlans-module__header___Wteua {
  display: flex;
  padding: 16px;
  justify-content: space-between;
}
.KnownPlans-module__container___qH2vh .KnownPlans-module__header___Wteua .KnownPlans-module__accordionContainer___DI4mz {
  display: flex;
  flex-direction: column;
  width: 70%;
  gap: 16px;
}
.KnownPlans-module__container___qH2vh .KnownPlans-module__header___Wteua .KnownPlans-module__button___fNCqM {
  height: 40px;
  margin: 10px;
}
.KnownPlans-module__container___qH2vh .KnownPlans-module__select___BTMBw {
  width: 170px;
}
.KnownPlans-module__container___qH2vh .KnownPlans-module__select___BTMBw > div:first-child {
  padding: 5px 10px !important;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/PatientDetails/fragments/KnownPlans/KnownPlans.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,aAAA;EACA,sBAAA;ECMA,0IDJE;ECKF,kBAAA;EACA,kBAAA;ADypBF;ACvpBE;EACE,oCAAA;EACA,mBAAA;ADypBJ;ACtpBE;EACE,UAAA;EACA,6BAAA;ADwpBJ;ACrpBE;EACE,aAAA;ADupBJ;AAnqBE;EACE,aAAA;EACA,aAAA;EACA,8BAAA;AAqqBJ;AAnqBI;EACE,aAAA;EACA,sBAAA;EACA,UAAA;EACA,SAAA;AAqqBN;AAlqBI;EACE,YAAA;EACA,YAAA;AAoqBN;AAhqBE;EACE,YAAA;AAkqBJ;AAhqBI;EACE,4BAAA;AAkqBN","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  display: flex;\n  flex-direction: column;\n  @include verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(\n          --patient-details-footer\n        )\n    )\n  );\n\n  .header {\n    display: flex;\n    padding: 16px;\n    justify-content: space-between;\n\n    .accordionContainer {\n      display: flex;\n      flex-direction: column;\n      width: 70%;\n      gap: 16px;\n    }\n\n    .button {\n      height: 40px;\n      margin: 10px;\n    }\n  }\n\n  .select {\n    width: 170px;\n\n    & > div:first-child {\n      padding: 5px 10px !important;\n    }\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `KnownPlans-module__font-s-10___tI8fG`,
	"fontS12": `KnownPlans-module__font-s-12___hTk6j`,
	"fontS13": `KnownPlans-module__font-s-13___Urdi0`,
	"fontS14": `KnownPlans-module__font-s-14___o0X6g`,
	"fontS15": `KnownPlans-module__font-s-15___MMW2V`,
	"fontS16": `KnownPlans-module__font-s-16___b3fkd`,
	"fontS18": `KnownPlans-module__font-s-18___RPWSq`,
	"fontS20": `KnownPlans-module__font-s-20___Y06B1`,
	"fontS22": `KnownPlans-module__font-s-22___aI6J0`,
	"fontS28": `KnownPlans-module__font-s-28___s57XL`,
	"fontW400": `KnownPlans-module__font-w-400___CDNfx`,
	"fontW500": `KnownPlans-module__font-w-500___i5kKo`,
	"fontW600": `KnownPlans-module__font-w-600___giGEx`,
	"fontW700": `KnownPlans-module__font-w-700___eLwtQ`,
	"p5": `KnownPlans-module__p-5___A5ypO`,
	"p12": `KnownPlans-module__p-12___PHeHX`,
	"p16": `KnownPlans-module__p-16___oL9X6`,
	"p30": `KnownPlans-module__p-30___kBNLh`,
	"pB0": `KnownPlans-module__p-b-0___OWuSO`,
	"pB5": `KnownPlans-module__p-b-5___qHqny`,
	"pB10": `KnownPlans-module__p-b-10___DZDPD`,
	"pB12": `KnownPlans-module__p-b-12___HpSq7`,
	"pB16": `KnownPlans-module__p-b-16___SpoY2`,
	"pB18": `KnownPlans-module__p-b-18___aUnw6`,
	"pB20": `KnownPlans-module__p-b-20___ZwsXD`,
	"pB25": `KnownPlans-module__p-b-25___aadML`,
	"pB30": `KnownPlans-module__p-b-30___U5CK6`,
	"pB50": `KnownPlans-module__p-b-50___yBcuV`,
	"pT0": `KnownPlans-module__p-t-0___LhuNc`,
	"pT12": `KnownPlans-module__p-t-12___t7RV9`,
	"pT16": `KnownPlans-module__p-t-16___peZ3k`,
	"pT18": `KnownPlans-module__p-t-18___U612B`,
	"pT20": `KnownPlans-module__p-t-20___wTN2l`,
	"pT30": `KnownPlans-module__p-t-30___Y0_eQ`,
	"pT40": `KnownPlans-module__p-t-40___CUP8x`,
	"pT50": `KnownPlans-module__p-t-50___HShWu`,
	"pL20": `KnownPlans-module__p-l-20___hGn4x`,
	"pL30": `KnownPlans-module__p-l-30___VjgXb`,
	"pL40": `KnownPlans-module__p-l-40___UPQP0`,
	"pR16": `KnownPlans-module__p-r-16___WofCW`,
	"pR20": `KnownPlans-module__p-r-20___k2XTz`,
	"pR30": `KnownPlans-module__p-r-30___jStkF`,
	"pR50": `KnownPlans-module__p-r-50___pMyVY`,
	"pR60": `KnownPlans-module__p-r-60___Ge2Ff`,
	"mB1": `KnownPlans-module__m-b-1___LZhZ3`,
	"mB2": `KnownPlans-module__m-b-2___M8_fr`,
	"mB6": `KnownPlans-module__m-b-6___kcsCD`,
	"mB8": `KnownPlans-module__m-b-8___GOA_y`,
	"mB10": `KnownPlans-module__m-b-10___a0oyx`,
	"mB14": `KnownPlans-module__m-b-14___M6sRy`,
	"mB16": `KnownPlans-module__m-b-16___iuRYh`,
	"mB20": `KnownPlans-module__m-b-20___Bt1gp`,
	"mB22": `KnownPlans-module__m-b-22___mFEQF`,
	"mB24": `KnownPlans-module__m-b-24___C3KW0`,
	"mB30": `KnownPlans-module__m-b-30___VCgZ4`,
	"mB32": `KnownPlans-module__m-b-32___VKgcw`,
	"mB40": `KnownPlans-module__m-b-40___ircS8`,
	"mT2": `KnownPlans-module__m-t-2___jKP0D`,
	"mT3": `KnownPlans-module__m-t-3___fL78P`,
	"mT4": `KnownPlans-module__m-t-4___QtnRo`,
	"mT5": `KnownPlans-module__m-t-5___uyFdD`,
	"mT8": `KnownPlans-module__m-t-8___wuvRH`,
	"mT10": `KnownPlans-module__m-t-10___IMm4t`,
	"mT15": `KnownPlans-module__m-t-15___uBu6O`,
	"mT16": `KnownPlans-module__m-t-16___xso8O`,
	"mT20": `KnownPlans-module__m-t-20___LPW6g`,
	"mT22": `KnownPlans-module__m-t-22___vqC5Y`,
	"mT30": `KnownPlans-module__m-t-30___QAj7j`,
	"mT32": `KnownPlans-module__m-t-32___icTMt`,
	"mLAuto": `KnownPlans-module__m-l-auto___tkva8`,
	"mL4": `KnownPlans-module__m-l-4___WcBla`,
	"mL5": `KnownPlans-module__m-l-5___McYSY`,
	"mL6": `KnownPlans-module__m-l-6___Vu7jG`,
	"mL8": `KnownPlans-module__m-l-8___GBzO3`,
	"mL10": `KnownPlans-module__m-l-10___1QF1j`,
	"mL16": `KnownPlans-module__m-l-16___a8TXb`,
	"mL20": `KnownPlans-module__m-l-20___R2pNQ`,
	"mL24": `KnownPlans-module__m-l-24___KMy1r`,
	"mL30": `KnownPlans-module__m-l-30___LfFJc`,
	"mL35": `KnownPlans-module__m-l-35___tOw_d`,
	"mL40": `KnownPlans-module__m-l-40___Mdnuf`,
	"mR8": `KnownPlans-module__m-r-8___hmpps`,
	"mR10": `KnownPlans-module__m-r-10___wDtOK`,
	"mR16": `KnownPlans-module__m-r-16___SbtdE`,
	"mR20": `KnownPlans-module__m-r-20___Ijf06`,
	"mR24": `KnownPlans-module__m-r-24___HkArc`,
	"mR30": `KnownPlans-module__m-r-30___u6l1O`,
	"mR40": `KnownPlans-module__m-r-40____KApX`,
	"borderR3": `KnownPlans-module__border-r-3___wWXn1`,
	"borderR4": `KnownPlans-module__border-r-4___Gg0rg`,
	"borderR6": `KnownPlans-module__border-r-6___pKo1K`,
	"borderR10": `KnownPlans-module__border-r-10___rqyO9`,
	"borderR12": `KnownPlans-module__border-r-12___aP53R`,
	"borderR16": `KnownPlans-module__border-r-16___qpX0U`,
	"borderR50": `KnownPlans-module__border-r-50___FLK3R`,
	"primaryBorder": `KnownPlans-module__primary-border___aUZZ4`,
	"primaryBorderB": `KnownPlans-module__primary-border-b___D9Ttf`,
	"primaryBorderT": `KnownPlans-module__primary-border-t___h4v3Z`,
	"primaryBorderL": `KnownPlans-module__primary-border-l___wy6FB`,
	"primaryBorderR": `KnownPlans-module__primary-border-r___LzW4B`,
	"secondaryBorder": `KnownPlans-module__secondary-border___JuLBk`,
	"secondaryBorderB": `KnownPlans-module__secondary-border-b___Qwe7p`,
	"secondaryBorderT": `KnownPlans-module__secondary-border-t___WDKQa`,
	"secondaryBorderL": `KnownPlans-module__secondary-border-l___jN0OI`,
	"secondaryBorderR": `KnownPlans-module__secondary-border-r___OGjhO`,
	"gap0": `KnownPlans-module__gap-0___M3m7n`,
	"gap2": `KnownPlans-module__gap-2___q_mtQ`,
	"gap4": `KnownPlans-module__gap-4___kdMEt`,
	"gap5": `KnownPlans-module__gap-5___R52Y5`,
	"gap6": `KnownPlans-module__gap-6___oY8pc`,
	"gap8": `KnownPlans-module__gap-8___mUuow`,
	"gap10": `KnownPlans-module__gap-10___NuCST`,
	"gap12": `KnownPlans-module__gap-12___mjqIf`,
	"gap14": `KnownPlans-module__gap-14___PZ0Tx`,
	"gap16": `KnownPlans-module__gap-16___kMrF3`,
	"gap18": `KnownPlans-module__gap-18___WfCrk`,
	"gap20": `KnownPlans-module__gap-20___16fZP`,
	"gap24": `KnownPlans-module__gap-24___dHiW7`,
	"gap26": `KnownPlans-module__gap-26___TpLRI`,
	"gap30": `KnownPlans-module__gap-30___a8BUz`,
	"gap32": `KnownPlans-module__gap-32___aZ5P6`,
	"gap40": `KnownPlans-module__gap-40___JPOUT`,
	"gap50": `KnownPlans-module__gap-50___CxPM3`,
	"flex1": `KnownPlans-module__flex-1___HEPUq`,
	"flexNone": `KnownPlans-module__flex-none___j1nGD`,
	"flexColumn": `KnownPlans-module__flex-column___tmUki`,
	"flexRow": `KnownPlans-module__flex-row___EC4Qg`,
	"verticallyCentered": `KnownPlans-module__vertically-centered___QHSi9`,
	"horizontallyCentered": `KnownPlans-module__horizontally-centered___OT8L7`,
	"horizontallyEnd": `KnownPlans-module__horizontally-end___nX46n`,
	"verticallyStart": `KnownPlans-module__vertically-start___MDIUq`,
	"spaceBetween": `KnownPlans-module__space-between___w7WWF`,
	"flexWrap": `KnownPlans-module__flex-wrap___n565R`,
	"height100": `KnownPlans-module__height-100____7D64`,
	"width50": `KnownPlans-module__width-50___JtWyl`,
	"width100": `KnownPlans-module__width-100___Mtd88`,
	"cursorPointer": `KnownPlans-module__cursor-pointer___kd77m`,
	"cursorNotAllowed": `KnownPlans-module__cursor-not-allowed___nn4fP`,
	"absoluteCentered": `KnownPlans-module__absolute-centered___YWBym`,
	"absolute": `KnownPlans-module__absolute___vY5EO`,
	"relative": `KnownPlans-module__relative___sPdZB`,
	"fixed": `KnownPlans-module__fixed___tdEkn`,
	"visible": `KnownPlans-module__visible___bfXXA`,
	"invisible": `KnownPlans-module__invisible___yTz4y`,
	"col90": `KnownPlans-module__col-90___qS3Uf`,
	"colAuto": `KnownPlans-module__col-auto___XyX26`,
	"medicalTabs": `KnownPlans-module__medical-tabs___eN1yF`,
	"medicalTableNew": `KnownPlans-module__medical-table-new___JhTv7`,
	"noPagination": `KnownPlans-module__no-pagination___aRAgl`,
	"medicalTableEmpty": `KnownPlans-module__medical-table-empty___xyG7O`,
	"iconBtn": `KnownPlans-module__icon-btn___UVR4w`,
	"searchIcon": `KnownPlans-module__search-icon___I2GdO`,
	"disableSelect": `KnownPlans-module__disable-select___CvKQL`,
	"breakWord": `KnownPlans-module__break-word___N5KHl`,
	"popupClearBtn": `KnownPlans-module__popup-clear-btn___QztpO`,
	"scrollMB20": `KnownPlans-module__scroll-m-b-20___PPPCg`,
	"container": `KnownPlans-module__container___qH2vh`,
	"header": `KnownPlans-module__header___Wteua`,
	"accordionContainer": `KnownPlans-module__accordionContainer___DI4mz`,
	"button": `KnownPlans-module__button___fNCqM`,
	"select": `KnownPlans-module__select___BTMBw`
};
module.exports = ___CSS_LOADER_EXPORT___;
